/* eslint-disable no-use-before-define */

import { deepExtract } from 'helpers/deep';

const SET_VENDOR_STATUS = 'classpass/vendor/SET_VENDOR_STATUS';

const STATUS = {
  AVAILABLE: 'available',
  LOADING: 'loading',
  PRELOADING: 'preloading',
};

const TRANSITIONS = [
  [STATUS.LOADING, STATUS.AVAILABLE],
  [STATUS.PRELOADING, STATUS.AVAILABLE],
  [STATUS.PRELOADING, STATUS.LOADING],
];

function canTransition(state, status, vendor) {
  const vendorStatus = selectStatus(state, vendor);
  return !!TRANSITIONS.find(([from, to]) => vendorStatus === from && status === to);
}

function hasExpired(state, status, vendor, duration = 0) {
  const now = Date.now();
  return isStatus(state, status, vendor) && now - deepExtract(`${vendor}.timestamp`, state, now) > duration;
}

function isStatus(state, status, vendor) {
  return selectStatus(state, vendor) === status;
}

function selectStatus(state, vendor) {
  return deepExtract(`${vendor}.status`, state, STATUS.PRELOADING);
}

function setStatus(status, vendor) {
  return { type: SET_VENDOR_STATUS, vendor, status };
}

export function reducer(state = {}, action = {}) {
  const { status, type, vendor } = action;
  switch (type) {
    case SET_VENDOR_STATUS:
      return canTransition(state, status, vendor)
        ? {
            ...state,
            [vendor]: { status, timestamp: Date.now() },
          }
        : state;
    default:
      return state;
  }
}

const withVendorState = (func, status) => (state = {}, ...args) => func(state.vendor, status, ...args);

export const hasLoadingExpired = withVendorState(hasExpired, STATUS.LOADING);
export const isAvailable = withVendorState(isStatus, STATUS.AVAILABLE);
export const isLoading = withVendorState(isStatus, STATUS.LOADING);
export const setAvailable = setStatus.bind(null, STATUS.AVAILABLE);
export const setLoading = setStatus.bind(null, STATUS.LOADING);
